import React from "react";
var __jsx = React.createElement;
import { useNavigate } from "react-router-dom";
import stl from "./YearTag.module.css";
var YearTag = function YearTag(_ref) {
  var title = _ref.title,
    url = _ref.url,
    id = _ref.id;
  var navigate = useNavigate();
  return /*#__PURE__*/React.createElement("button", {
    id: id,
    className: stl.tag,
    onClick: function onClick() {
      navigate(url);
    }
  }, title, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "8",
    viewBox: "0 0 8 8",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.82253 0.183542C7.58589 -0.0530906 7.20364 -0.0530906 6.96701 0.183542L4 3.14448L1.03299 0.177474C0.796359 -0.0591581 0.414107 -0.0591581 0.177474 0.177474C-0.0591581 0.414107 -0.0591581 0.796359 0.177474 1.03299L3.14448 4L0.177474 6.96701C-0.0591581 7.20364 -0.0591581 7.58589 0.177474 7.82253C0.414107 8.05916 0.796359 8.05916 1.03299 7.82253L4 4.85552L6.96701 7.82253C7.20364 8.05916 7.58589 8.05916 7.82253 7.82253C8.05916 7.58589 8.05916 7.20364 7.82253 6.96701L4.85552 4L7.82253 1.03299C8.05309 0.802427 8.05309 0.414107 7.82253 0.183542Z",
    fill: "white"
  })));
};
export default YearTag;